import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';

@Pipe({ name: 'thousand' })
export class ThousandPipe implements PipeTransform {

    constructor() {

    }

    transform(value: number | string, locale: string = 'es'): string {
        // Normaliza el locale
        let normalizedLocale = locale;
        if (locale === 'pt_br') normalizedLocale = 'pt-BR';
        if (locale === 'en') normalizedLocale = 'en-US';
        if (locale === 'es') normalizedLocale = 'es-ES';

        // Convierte a número si es string
        let num = typeof value === 'string' ? parseFloat(value.replace(/,/g, '')) : value;
        if (isNaN(num)) return '';

        // Formatea el número según el locale
        return num.toLocaleString(normalizedLocale, { minimumFractionDigits: 0, maximumFractionDigits: 2 });
    }

    sortDecimal(string) {
        let index = string.indexOf(",");
        if (index != -1) {
            string = string.substring(0, index + 3);
        }
        return string;
    }
}